export const posdevice = {
  seo: {
    title: 'Bistroo Device for takeaway & delivery restaurants',
    description: 'The Bistroo Device is the ideal compact handheld for takeaway and delivery restaurants, fully integrated with your webshop, QR table ordering or self-order kiosk.',
  },
  hero: {
    title: {
      pt1: 'A ready-to-use',
      pt2: 'Bistroo Device',
      pt3: 'for online orders',
    },
    description:
      'The only device you need to process orders. Receive, manage and print. All from one portable device.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Plug & play, serve all day',
      text: 'No complicated installation or technical knowledge required. Simply switch on the device and get straight to work. Start accepting your first order within minutes.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Manage, confirm & print orders',
      text: 'Process orders effortlessly from the device, confirm with one tap and manually communicate the expected pickup or delivery time. Easily process a refund at any time. No extra printer needed — everything is built in.',
      cta: '',
    },
    paragraph_3: {
      title: 'Update your shop at any moment',
      text: 'Easily close last-minute time slots, temporarily disable products and quickly print your (daily) revenue overview. Everything at your fingertips, exactly when you need it.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'No cables, no chaos',
      text: 'Fully wireless with a long battery life — no cable clutter on your kitchen floor. Inside or outside, with WiFi and 4G you can accept orders at any location. You are always online.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Order management.',
        text: 'Manage your orders in real time and keep a clear overview of all processes.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Know what you earn.',
        text: 'View your revenue for a given period with one simple click.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Time is in your hands.',
        text: 'Manage your time slots effortlessly to prevent kitchen bottlenecks and optimize your workflow.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Out of stock, no problem.',
        text: 'Manage your product inventory in real time with one click.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Distribution settings.',
        text: 'Change your distribution settings in real time and adjust them quickly.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Bistroo thinks along with us in terms of solutions and new opportunities."',
    cta: 'Read the full story',
    name: 'Il Municipio',
    job_title: 'Italian Restaurant',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo Device',
    items: [
      { q: 'What is the Bistroo Device?', a: 'The Bistroo Device is a compact, portable handheld for receiving, managing and printing orders. It is the only device you need to fully process your online orders.' },
      { q: 'How quickly can I get started with the Bistroo Device?', a: 'The device is plug-and-play: switch it on, connect to Wi-Fi and you immediately start receiving orders. No installer needed, no technical knowledge required.' },
      { q: 'Does the Bistroo Device have a built-in printer?', a: 'Yes. The printer is built into the device. No separate printer needs to be connected. Every order instantly prints the desired receipt for the kitchen or the customer.' },
      { q: 'Can I use the device outdoors or on the go?', a: 'Yes. The device works fully wirelessly via Wi-Fi and 4G. You can process orders on the terrace, at an event or on the road — always connected.' },
      { q: 'How long does the battery last?', a: 'The battery is designed for a full working day. During busy shifts we recommend charging the device in between using the included charger.' },
      { q: 'How do I confirm an order via the device?', a: 'When a new order comes in, it appears directly on the screen. With one tap you confirm the order and communicate the expected pickup or delivery time to the customer.' },
      { q: 'Can I manage time slots and product stock via the device?', a: 'Yes. Via the device you can quickly close time slots, temporarily deactivate products and adjust your offering in real time. Handy when a dish runs out or the kitchen needs a breather.' },
      { q: 'Can the Bistroo Device be connected to my webshop and kiosk?', a: 'Yes. The device receives orders from all Bistroo channels: your webshop, kiosk, QR table ordering and the Bistroo ordering service. Everything on one device.' },
      { q: 'How do I process refunds via the device?', a: 'In the orders overview on the device, select the order and choose Refund. The amount is immediately returned to the customer\'s account.' },
      { q: 'What does the Bistroo Device cost?', a: 'The device is available via rental or purchase, combined with a Bistroo software package. Contact us via bistroo.nl for a current tailored price quote.' },
    ],
  },
}
